__turbopack_context__.v({
  "addToCart": "r3i7aG_addToCart",
  "container": "r3i7aG_container",
  "description": "r3i7aG_description",
  "footerContainer": "r3i7aG_footerContainer",
  "metaContainer": "r3i7aG_metaContainer",
  "modificationsContainer": "r3i7aG_modificationsContainer",
  "priceLabel": "r3i7aG_priceLabel",
  "productImage": "r3i7aG_productImage",
  "productName": "r3i7aG_productName",
  "quantityModifier": "r3i7aG_quantityModifier",
  "variantContainer": "r3i7aG_variantContainer",
  "variantItem": "r3i7aG_variantItem",
  "variantName": "r3i7aG_variantName",
  "variantNameContainer": "r3i7aG_variantNameContainer",
  "variantPrice": "r3i7aG_variantPrice",
  "variantSelection": "r3i7aG_variantSelection",
  "variantTitle": "r3i7aG_variantTitle",
});
